import '../../css/blocks/case-studies-grid.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const caseStudiesGridBlocks = document.querySelectorAll('.case-studies-grid');
  
  if (caseStudiesGridBlocks.length) {
    // Initialize block-specific functionality here
  }
});
